let currentConfig = null;

export function setCurrentConfig(config) {
  currentConfig = config;
}

export function getCurrentConfig() {
  return currentConfig;
}